import { render, staticRenderFns } from "./GQLAll.vue?vue&type=template&id=5adaccab"
import script from "./GQLAll.vue?vue&type=script&lang=js"
export * from "./GQLAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports